import { useEffect, useRef } from "react";
import { io }               from "socket.io-client";
import { useAuthStore }      from "../context/store.js";
import { useChatStore }      from "../context/store.js";
import { useSpacesStore }    from "../context/store.js";
import { useUIStore }        from "../context/store.js";
import { useFeedStore }      from "../context/store.js";

let socketInstance = null;

export function getSocket() { return socketInstance; }

export function useSocket() {
  const token         = useAuthStore(s => s.token);
  const addMsg        = useChatStore(s => s.addMessageFromSocket);
  const setTyping     = useChatStore(s => s.setTyping);
  const updateListeners = useSpacesStore(s => s.updateListeners);
  const setIncoming   = useUIStore(s => s.setIncomingCall);
  const addNotif      = useUIStore(s => s.addNotification);
  const addVibe       = useFeedStore(s => s.addVibeFromSocket);
  const initialized   = useRef(false);

  useEffect(() => {
    if (!token || initialized.current) return;
    initialized.current = true;

    socketInstance = io(import.meta.env.VITE_SOCKET_URL || "http://localhost:4000", {
      auth: { token },
      transports: ["websocket", "polling"],
      reconnection: true,
      reconnectionDelay: 1000,
    });

    socketInstance.on("connect", () => console.log("🔌 Socket connected"));
    socketInstance.on("disconnect", () => console.log("🔴 Socket disconnected"));
    socketInstance.on("connect_error", (err) => console.error("Socket error:", err.message));

    // ── Chat events ──
    socketInstance.on("chat:newMessage",  addMsg);
    socketInstance.on("chat:typing",      setTyping);

    // ── Space events ──
    socketInstance.on("space:listeners",  updateListeners);

    // ── Call events ──
    socketInstance.on("call:incoming", (data) => {
      setIncoming({ type: data.callType, user: data.from, offer: data.offer, socketId: data.socketId });
    });
    socketInstance.on("call:rejected", () => {
      useUIStore.getState().showToast("Call was declined", "error");
      useUIStore.getState().setActiveCall(null);
    });
    socketInstance.on("call:ended", () => {
      useUIStore.getState().setActiveCall(null);
    });

    // ── Feed events ──
    socketInstance.on("feed:newVibe", addVibe);

    // ── Notifications ──
    socketInstance.on("notification:new", addNotif);

    return () => {
      socketInstance?.disconnect();
      socketInstance = null;
      initialized.current = false;
    };
  }, [token]);

  return socketInstance;
}
